import type { ProjectRouter } from "replo-publisher/src/trpc/routers/project";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: projectRouter,
  client: projectClient,
  utils: projectUtils,
  options: projectOptions,
} = createTrpcRouterConfig<ProjectRouter>({
  path: "project",
  queryClient: getNamespacedQueryClient("project"),
});

export { projectClient, projectRouter, projectUtils, projectOptions };
